// extracted by mini-css-extract-plugin
export default {"totalPrice":"total-price_totalPrice__QoACV"};